export default __webpack_public_path__ + "static/media/EH.f5ee0a5e.svg";